<template>
    <div>
        <!--
        <h2>{{ username }}</h2>
        <h2>{{ password }}</h2>
        <h2>{{ liveJampDeviceId }}</h2>
        -->
    </div>
</template>

<script>
import Version from "@/version.json";
export default {
    name: "openCage",
    data() {
        return {
            ver: Version.version,
            dbVersion: [],
            username: "",
            password: "",
            lineId: "",
            liveJampDeviceId: 0,
            videoTime: "",
            dbUsers: [],
            isLoading: false
        };
    },
    //==========================================
    created: async function() {
        this.username = this.$route.query.id;
        this.password = this.$route.query.pass;
        this.liveJampDeviceId = this.$route.query.cage;
        this.videoTime = this.$route.query.time;

        this.isLoading = true;
        await new Promise(r => setTimeout(r, 1000));
        this.jwtauth();
        this.isLoading = false;
    },
    //==========================================
    mounted: function() {},
    //==========================================
    updated: function() {},
    //==========================================
    methods: {
        //-----------------------------------------
        jwtauth() {
            this.axios({
                method: "POST",
                url: "/web/api/authenticate",
                data: {
                    username: this.username.trim(),
                    password: this.password.trim()
                },
                timeout: 5000 // 5000ms
            })
                .then(response => {
                    let jwt = response.data.token;
                    this.dbUsers = response.data.json;
                    if (jwt) {
                        this.$localStorage.set("jwt", jwt);
                        this.$localStorage.set("username", this.username.trim());
                        this.$localStorage.set("password", this.password.trim());
                        if (this.liveJampDeviceId) {
                            if (this.videoTime) this.videoTime = this.$moment(this.videoTime, "YYYYMMDDHHmmss").format("YYYY-MM-DD HH:mm:ss");
                            this.$router.push({ path: "/playback/" + this.liveJampDeviceId + "/?time=" + this.videoTime });
                        } else {
                            this.$router.push({ path: "/" });
                        }
                    } else {
                        alert("登録がありません。");
                    }
                })
                .catch(error => {
                    alert("認証エラー");
                    self.console.log(error);
                });
        }
        //-----------------------------------------
    }
};
</script>
